export function includeGoogleAnalytics() {
  if (import.meta.env.MODE !== "production") return;

  const MEASUREMENT_ID = "G-CODE";
  const GTM_URL = `https://www.googletagmanager.com/gtag/js?id=${encodeURIComponent(
    MEASUREMENT_ID,
  )}`;

  // Create (or reuse) a strict Trusted Types policy
  let policy: typeof window.__gaGtmPolicy | null = null;
  if (window.trustedTypes) {
    policy =
      window.__gaGtmPolicy ??
      (window.__gaGtmPolicy = window.trustedTypes.createPolicy("ga-gtm", {
        createScriptURL: (url: string) => {
          // Only allow the canonical GTM host + path + an expected ID
          const u = new URL(url);
          const hostOK = u.origin === "https://www.googletagmanager.com";
          const pathOK = u.pathname === "/gtag/js";
          const id = u.searchParams.get("id");
          const idOK = typeof id === "string" && /^G-[A-Z0-9]+$/i.test(id);
          if (hostOK && pathOK && idOK) return url;
          throw new TypeError(
            "Blocked by Trusted Types policy: invalid GTM URL",
          );
        },
      }));
  }

  // Load the tag with a TrustedScriptURL (or plain string as a fallback)
  const script = document.createElement("script");
  script.async = true;
  // If TT is enforced and supported, this must be a TrustedScriptURL
  script.src = (
    policy ? policy.createScriptURL(GTM_URL) : (GTM_URL as unknown)
  ) as any;
  document.head.appendChild(script);

  // Standard GA bootstrap
  window.dataLayer = window.dataLayer || [];
  function gtag(...args: any[]) {
    window.dataLayer.push(args);
  }
  window.gtag = window.gtag || gtag;

  gtag("js", new Date());
  gtag("config", MEASUREMENT_ID);
}
